import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue'
  import { getImagePath } from '@/utils'
  import fallbackImage from '@/assets/no-img.jpg'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BookingImage',
  props: {
    image: {
      type: String,
      required: false,
    },
  },
  setup(__props) {

  const props = __props

  const resolvedImagePath = computed(() =>
    props.image ? getImagePath(props.image) : fallbackImage
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      src: resolvedImagePath.value,
      alt: "Booking Image",
      class: "img-fluid border-radius-default"
    }, null, 8, _hoisted_1)
  ]))
}
}

})